<ng-container *ngIf="showNavMenu">
  <header class="navbar-header">
    <nav
      class="navbar navbar-style navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
      <div class="nav-menu">
        <a (click)="toggleLeftNav()" class="navbar-icon-wrapper">
        <div class="navbar-icon">
          <img *ngIf="!showLeftNav" src="./assets/images/open-sidebar.svg" width="32" class="filter-invert" />
          <img *ngIf="showLeftNav" src="./assets/images/close-sidebar.svg" width="32"/>
        </div>
        </a>
        <div class="navbar-spacer"></div>
        <div>
          <a class="navbar-brand" [routerLink]='["/"]'><img src="./assets/images/logo-horizontal.svg" width="175"/></a>
          <div class="navbar-title">
          {{navTitle?.title}}
           </div>
          <div *ngIf="!navTitle?.title.includes('Report')" class="navbar-subtitle">
          {{navTitle?.subtitle}}
          </div>
        </div>
     </div>
      <div style="display: flex; flex-wrap: wrap; justify-content: flex-end; align-items: center;">
        <div *ngIf="showButton" class="d-flex">
          <div *ngIf="isOrderInProcess" class="mr-1 d-flex">
            <div class="d-flex align-items-center">
              <span style="padding-right: 5px"><b>Assigned Rep: </b></span>
              <p-multiSelect styleClass="simple-control assigned-rep-dropdown" appendTo="self" [showToggleAll]="false"
                (onChange)="onAgentDropDownSelect($event.value)" [options]="proxyOptions" [(ngModel)]="selectedProxy"
                [disabled]="isLoading" class="multiselect-container">
                <ng-template pTemplate="footer">
                  <div class="multiselect-footer-buttons">
                    <button type="button" class="btn-select-all" (click)="selectAllAgents()" title="Select All">
                      <i class="pi pi-check-square"></i> Select All
                    </button>
                    <button type="button" class="btn-clear-all" (click)="clearAllAgents()" title="Clear All">
                      <i class="pi pi-times-circle"></i> Clear All
                    </button>
                  </div>
                </ng-template>
              </p-multiSelect>
            </div>
           <button class="custom-button ml-1 pr-2" style="margin-left:8px;vertical-align:top;" (click)="assignSelectedReps()">
             <img src="./assets/images/search-icon.svg" width="18"> Search
           </button>
          </div>
          <button class="custom-button" *ngIf="status=='canceled' && sharedServiceClient.getPermissions('tenders')" (click)="clickActive()">
            <span style="padding-right: 2px;"><img src="./assets/images/ok-icon.svg" width="16" /></span>
            <span style="padding-right: 5px">Revive Tenders</span>
          </button>
          <button class="custom-button" *ngIf="status=='active' && currentModule == 'tenders' && sharedServiceClient.getPermissions('tenders')" (click)="clickCancel()">
            <span style="padding-right: 5px;"><img src="./assets/images/cancel.svg" width="16" /></span>
            <span style="padding-right: 5px">Cancel Tenders</span>
          </button>
          <button *ngIf="button != null && status=='active' && sharedServiceClient.getPermissions('tenders')" class="custom-button" (click)="click()">
            <span *ngIf="button?.icon" style="padding-right: 5px;"><img [src]="'./assets/images/'+ button?.icon + '.svg'"
                width="16" /></span>
            <span style="padding-right: 5px">{{button?.label}}</span>
          </button>
          <button class="custom-button" *ngIf="isReadyToDispatch && sharedServiceClient.getPermissions('orders_edit')" (click)="clickBulkEdit()">
            <!-- <span style="padding-right: 5px;"></span> -->
            <span *ngIf="!isBulkEdit"><img src="./assets/images/cancel1-svgrepo-com.svg" alt="cancel-logo" width="16" />Cancel Bulk Edit</span>
            <span *ngIf="isBulkEdit"><img src="./assets/images/edit-bulk.svg" alt="edit-bulk-logo" width="16"  style="margin-right: 5px;"/>Bulk Edit</span>
          </button>
          <button class="custom-button" [disabled]="isBeginBulkEditEnable" *ngIf="isReadyToDispatch && !isBulkEdit && sharedServiceClient.getPermissions('orders_edit')" (click)="clickBeginBulkEdit()">
            <span style="padding-right: 5px;"><img src="./assets/images/bulk-edit-svgrepo-com.svg" alt="bulk-edit-logo" width="16" /></span>
            <span style="padding-right: 5px">Begin Bulk Edit</span>
          </button>

          <button class="custom-button" *ngIf="isAccountingNav && sharedServiceClient.getPermissions('invoices')" (click)="clickAccountingBulkEdit()">
            <!-- <span style="padding-right: 5px;"></span> -->
            <span *ngIf="!isAccountingBulkEdit"><img src="./assets/images/cancel1-svgrepo-com.svg" alt="cancel-logo" width="16" />Cancel Bulk Edit</span>
            <span *ngIf="isAccountingBulkEdit"><img src="./assets/images/edit-bulk.svg" alt="edit-bulk-logo" width="16"  style="margin-right: 5px;"/>Bulk Edit</span>
          </button>
          <button class="custom-button" [disabled]="isBeginAccountingBulkEditEnable" *ngIf="isAccountingNav && !isAccountingBulkEdit && sharedServiceClient.getPermissions('invoices')" (click)="clickBeginAccountingBulkEdit()">
            <span style="padding-right: 5px;"><img src="./assets/images/bulk-edit-svgrepo-com.svg" alt="bulk-edit-logo" width="16" /></span>
            <span style="padding-right: 5px">Begin Bulk Edit</span>
          </button>

          <button class="custom-button" *ngIf="sharedServiceClient.getPermissions('creation_new_order')" (click)="clickNewOrder()">
            <span style="padding-right: 5px;"><img src="./assets/images/new-order.svg" width="16" /></span>
            <span style="padding-right: 5px">New Order</span>
          </button>
          <button class="custom-button" *ngIf="sharedServiceClient.getPermissions('creation_new_user')" (click)="clickNewUser()">
            <span style="padding-right: 5px;"><img src="./assets/images/add-user-white.svg" width="16" /></span>
            <span style="padding-right: 5px">New User</span>
          </button>
          <button class="custom-button" *ngIf="sharedServiceClient.getPermissions('creation_new_location')" (click)="clickNewLocation()">
            <span style="padding-right: 5px;"><img src="./assets/images/add-location.svg" width="16" /></span>
            <span style="padding-right: 5px">New Location</span>
          </button>
        </div>
        <div *ngIf="showFilter && !isReporting" class="keywords">
          <span style="position: relative; left: 32px"><img src="./assets/images/filter.svg" class="filter-invert" width="16" /></span>
          <input appSanitizeInput class="filter" type="text" placeholder="Keywords..." [ngModel]="filter"
            (ngModelChange)="filterChange($event)"  [disabled]="isLoading"/>
        </div>
        <div class="darkmode-icon" [ngClass]=" getCurrentMode() ? 'darkmode-icon--dark' : 'darkmode-icon--light'">
          <img *ngIf="!getCurrentMode()" (click)="switchMode()" src="./assets/images/dark-mode-icon.png"  class="dark-icon filter-invert" alt="dark-icon">
          <img *ngIf="getCurrentMode()" (click)="switchMode()" src="./assets/images/light_mode-icon.svg" class="light-icon filter-invert" alt="light-icon">
        </div>
      </div>
    </nav>
  </header>
</ng-container>
